/*
 * School Users — standalone page (mirrors the Portfolio "Users" approach).
 * Mounted at /diagnostic/users. Restricted to tenant_admin / admin / super_admin.
 * Reuses the UsersTab from TenantSettingsPage so there is a single source of
 * truth for tenant user management (invite, edit role/name, reset password,
 * deactivate / reactivate, seat requests).
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { Shell } from "./CaporilliWorkspace";
import { UsersTab } from "./TenantSettingsPage";

const getSession = () => { try { return JSON.parse(localStorage.getItem("diag_session") || "null"); } catch { return null; } };

const TenantUsersPage = () => {
  const navigate = useNavigate();
  const session = getSession();

  useEffect(() => {
    if (!session) { navigate("/diagnostic/login", { replace: true }); return; }
    if (!["tenant_admin", "admin", "super_admin"].includes(session.user?.role)) {
      toast.error("User management is restricted to tenant admins.");
      navigate("/diagnostic", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Shell>
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 py-8" data-testid="tenant-users-page">
        <div className="flex items-center gap-3 mb-6">
          <Users className="h-6 w-6 text-[#3B4FE4]" />
          <div>
            <h1 className="text-2xl font-bold text-[#111827]">Users</h1>
            <p className="text-[13px] text-[#6b7280]">Invite team members, set their role, reset passwords, and manage seats.</p>
          </div>
        </div>
        <UsersTab />
      </div>
    </Shell>
  );
};

export default TenantUsersPage;
